import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react'

import { usePrincipal } from '../../authentication'

export interface AnalyticsTracker {
  setUserId: (id: string) => void
}

interface AnalyticsTrackingManagerProps extends PropsWithChildren {
  analyticsTracker?: AnalyticsTracker
}

export const AnalyticsTrackingManager: FunctionComponent<
  AnalyticsTrackingManagerProps
> = ({ analyticsTracker, children }: AnalyticsTrackingManagerProps) => {
  const { user, isAdmin } = usePrincipal()

  useEffect(() => {
    if (analyticsTracker && !isAdmin) {
      analyticsTracker.setUserId(user.userId)
    }
  }, [user, isAdmin])

  return <>{children}</>
}
